

<div *ngIf="productData" class="postbox  mb-2 secondary-paragraph repost_disabled user-card p-2 bg-white">
  <div *ngIf="productType == 27" >
    <app-webinar-card [docCardObj]="productData" [callingfrom]="this.screenName.CREATE_USER_STORY" [docTalkSection]=''
                [listLength]="numbers.ONE"></app-webinar-card>
</div>
<div *ngIf="productType === 1" >
    <app-feed-card
    [callingfrom]="'CREATE_USER_STORY'"
    [feedObj]="productData"
    [source]="numbers.ONE"
    [ptoductType]="numbers.ONE"
    [feedIdx]="numbers.ONE"
    [textHeighlight]=""
    [flags]="numbers.ONE">
  </app-feed-card>
</div>

  <div *ngIf="productType === 3" >
    <app-clinical-resource-card
    [callingfrom]="this.screenName.CREATE_USER_STORY"
    [clinicalObj]="productData"
    [idx]="index"  >
  </app-clinical-resource-card>
  </div>

  <div *ngIf="productType === 24">
    <app-web-doctalk-card
      [callingfrom]="this.screenName.CREATE_USER_STORY"
      [docCardObj]='productData'
      [docTalkSection]='"features_videos"'
      [listLength]=2>
    </app-web-doctalk-card>
  </div>

</div>
